import { UBICACIONES } from "../data/content";

export const Ubicaciones = () => {
  return (
    <section id="ubicaciones" data-testid="ubicaciones-section" className="py-24 md:py-32 bg-[#F4F2F7]">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-16">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div>
            <p className="text-xs uppercase tracking-overline text-[#5B3E96] font-semibold mb-5">
              {UBICACIONES.overline}
            </p>
            <h2 className="font-serif-display text-3xl md:text-5xl font-semibold text-[#2D1B4E] tracking-tight leading-[1.1]">
              {UBICACIONES.title}
            </h2>
            <p className="mt-6 text-base text-[#5F5670] leading-relaxed max-w-md">
              {UBICACIONES.address}
            </p>

            <div className="mt-8 space-y-5">
              {UBICACIONES.facts.map((f) => {
                const Icon = f.icon;
                return (
                  <div key={f.label} className="flex items-start gap-4">
                    <span className="flex items-center justify-center w-11 h-11 bg-white border border-[#E8E4EE] rounded-sm shrink-0">
                      <Icon strokeWidth={1.5} className="w-5 h-5 text-[#5B3E96]" />
                    </span>
                    <div>
                      <p className="text-xs uppercase tracking-overline text-[#5F5670]">{f.label}</p>
                      <p className="text-sm text-[#1A1523] mt-1">{f.value}</p>
                    </div>
                  </div>
                );
              })}
            </div>

            <a
              href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent("Universidad Politécnica de Pachuca Zempoala Hidalgo")}`}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="ubicaciones-maps-link"
              className="inline-block mt-8 bg-[#2D1B4E] text-white text-sm font-medium px-6 py-3.5 rounded-sm hover:bg-[#1A1523] transition-colors"
            >
              Cómo llegar
            </a>
          </div>

          <div className="rounded-sm overflow-hidden border border-[#E8E4EE] shadow-lg">
            <iframe
              title="Mapa Universidad Politécnica de Pachuca"
              src={UBICACIONES.mapEmbed}
              data-testid="ubicaciones-map"
              className="w-full h-[420px]"
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
          </div>
        </div>
      </div>
    </section>
  );
};
